import React, { FC } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { CoreUtils } from '@nhl/nhl-breakaway-ui';
import { TeamDisplay } from '@nhl/nhl-react-ui/lib/TeamDisplay';

import commonMessages from '~/core/commonMessages';

import { AwayAndHomeTeam, GameCenterTeam, LandingGame, PlayoffsRecord as PlayoffsRecordType } from '../../types';

import {
    Header,
    PlayoffsRecordContainer,
    Record,
    RecordContainer,
    Streak,
    TeamContainer,
    TeamLogoContainer,
    TeamName,
} from './styles';

type Props = {
    game: LandingGame;
    playoffsRecord: AwayAndHomeTeam<PlayoffsRecordType>;
};

const TeamRecord: FC<{ team: GameCenterTeam; record: PlayoffsRecordType }> = ({ team, record }) => {
    const intl = useIntl();
    const streakCode = CoreUtils.safeFormatMessage(
        intl,
        commonMessages.statsDescriptions.abbreviations[record.streakType]
    );
    return (
        <TeamContainer>
            <TeamLogoContainer>
                <TeamDisplay logoUrlOverride={team.logo} team={{ triCode: team.abbrev }} displayName={false} />
            </TeamLogoContainer>
            <TeamName>{team.abbrev}</TeamName>
            <RecordContainer>
                <Record>{record.record}</Record>
                <Streak>
                    <FormattedMessage
                        {...commonMessages.gameInformationDescriptions.long.teamsStreak}
                        values={{
                            streakCode,
                            streakCount: record.streak,
                        }}
                    />
                </Streak>
            </RecordContainer>
        </TeamContainer>
    );
};

const PlayoffsRecord: FC<Props> = ({ game, playoffsRecord }) => (
    <PlayoffsRecordContainer>
        <Header role="heading" aria-level={2}>
            <FormattedMessage
                description="A phrase describing a teams record in the playoffs and streak infomation. Ex. 1-0 Streak W1"
                defaultMessage="Playoffs Record"
            />
        </Header>
        <TeamRecord team={game.awayTeam} record={playoffsRecord.awayTeam} />
        <TeamRecord team={game.homeTeam} record={playoffsRecord.homeTeam} />
    </PlayoffsRecordContainer>
);

export default PlayoffsRecord;
